export class EmptyCodeAsNoValueConverter {
	public toView(value) {
		if (value == null || value.trim().length === 0) {
			return 'N';
		}

		return value;
	}
}
